<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/shopInfoList' }">运输公司管理列表</el-breadcrumb-item>
      <el-breadcrumb-item>付款信息列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForRef"
          autocomplete="on">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="开始添加时间" size="small" label-width="100px">
              <el-date-picker v-model="searchForm.start_time" type="date"  placeholder="请选择开始时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="结束添加时间" size="small" label-width="100px">
              <el-date-picker v-model="searchForm.end_time" type="date"  placeholder="请选择结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="关键字" size="small" label-width="100px">
              <el-input v-model="searchForm.queryParams"  placeholder="付款人|付款人帐号|运输公司" clearable type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="付款账号" size="small" label-width="100px">
              <el-input v-model="searchForm.payer_account_number" placeholder="请输入付款账号" clearable type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-button size="small" type="success" @click="searchSubmit()">搜索</el-button>
            <!-- <el-button @click="searchRest()">重置</el-button> -->
          </el-col>
          <el-col :span="1">
            <el-button size="small" type="primary" @click="addData">新增</el-button>
          </el-col>
        </el-row>
      </el-form>

      <!-- 表格 -->
      <el-table ref="multipleTable" :data="tableLoadData" stripe border size="mini" :header-cell-style="{background:'#e5e5e5',color:'#333333'}">
        <el-table-column
            label="ID"
            min-width="5%"
            prop="id"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="经办人"
            min-width="10%"
            prop="op_name"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="运输公司"
            min-width="10%"
            prop="shop_name"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="付款人"
            min-width="10%"
            prop="payer_account"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="付款账号"
            min-width="10%"
            prop="payer_account_number"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="交易时间"
            min-width="10%"
            prop="add_time"
            :show-overflow-tooltip='true'>
          <template slot-scope="scope">{{ scope.row.add_time | dateFormat }}</template>
        </el-table-column>

        <el-table-column
            label="备注"
            min-width="10%"
            prop="remark"
            :show-overflow-tooltip='true'></el-table-column>

        <el-table-column
            label="操作"

            width="150">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" icon="el-icon-edit" @click="handelEdit(scope.row)"></el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="handelDel(scope.row)"></el-button>
            
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="70%">
      <el-form :model="form" :rules="rules" ref="form" label-width="110px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="付款人" size="small">
              <el-input v-model="form.payer_account" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款人帐号" prop="" size="small">
              <el-input v-model="form.payer_account_number" autocomplete="off"  class="setValue"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="开户行" prop="" size="small">
              <el-input v-model="form.payer_bank" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="" size="small">
              <el-input v-model="form.remark" type="textarea" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
  import eTable from "../common/eTable.vue";
  import moment from 'moment';    //日期时间转换
  import eCar from "../common/eCar";
  export default {
    name: "payList",
    components: {
      eTable,
      eCar
    },
    props: {},
    data() {
      return {
        isShowCar:false,
        // 搜索
        searchForm: {
          start_time: '',
          end_time:'',
          queryParams:'',
          payer_account:'',
          payer_account_number:''
        },
        searchRules: {
        },
        // 数据
        tableLoadData: [],
        limit: 10,
        page:1,// 当前页码
        total:0,//总条目数
        id: '',
        shop_id: this.$route.params.id,
        rules: {
        },
        dialogFormVisible: false,
        title: '',
        form: {
          payer_account: '', //付款人
          payer_account_number: '', //付款人帐号
          payer_bank: '', //payer_bank
          shop_id: '', //所属运输公司ID
          remark:'', //备注
        },
        uploadImg: '',
        uploadDialog: false,
        
      };
    },
    created() {
      this.shop_id = this.$route.query.id,
      this.DataList()
    },
    mounted() {
    },
    filters: {
      statusFilter(status) {
        if (status == 1) {
          return "启用";
        } else if (status == 2) {
          return "禁用";
        }
      },
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
      },

    },
    methods: {
      getTime (time) {
        var date = new Date(time)
        var y = date.getFullYear()
        var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
        var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
        return y + '-' + m + '-' + d
      },
      chooseCar(){
        this.isShowCar=true;
        //console.log('dddd',this.isShowCar)
      },
      //接收子组件传过来的值
      chooseCarInfo(car_number,...params){
        this.searchForm.name=car_number;
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          shop_id:this.shop_id,
          page: this.page,
          pageSize:this.limit
        }
        if(this.searchForm.queryParams) param.queryParams = this.searchForm.queryParams
        if(this.searchForm.payer_account) param.payer_account = this.searchForm.payer_account
        if(this.searchForm.payer_account_number) param.payer_account_number = this.searchForm.payer_account_number
        if(this.searchForm.start_time) param.start_time =  this.getTime(this.searchForm.start_time)
        if(this.searchForm.end_time) param.end_time = this.getTime(this.searchForm.end_time)
        this.$axios.getShopPayPageList(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          //console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.limit = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.page = newPage
        this.DataList()
      },
      // 新增
      addData() {
        this.title = '新增'
        this.form = {
          // role_name: '',
        }
        this.dialogFormVisible = true
      },
      handelEdit(index,row) {
        this.id = index.id

        this.title = '编辑'
        this.form = {
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index))
      },
      
      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const param = {
              payer_account: this.form.payer_account, //付款人
              payer_account_number: this.form.payer_account_number, //付款人帐号
              payer_bank: this.form.payer_bank, //payer_bank
              shop_id: this.shop_id, //所属运输公司ID
              remark:this.form.remark, //备注
              operator_id: sessionStorage.getItem('user_id'),
              company_id:sessionStorage.getItem('company_id'),
              access_token:sessionStorage.getItem('token')
            }
            if(this.id) param.id = this.form.id
            this.$axios.saveShopPayPageList(param).then(res =>{
              if(res.code == 200){
                this.DataList()
                this.$message.success(res.msg)
                this.dialogFormVisible = false
              }else{
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      searchSubmit() {
        this.page = 1,
        this.DataList()
      },
      handelDel(e) {
        this.$confirm('此操作将删除该支付信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.id,
          }
          //console.log(param);
          this.$axios.delShopPayPageList(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            //console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },
    },
  };
</script>
<style>
  .table_name{
    font-weight: bold;
    /* border: 1px solid #f00; */
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
  .el-dialog,.el-dialog__body{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/view/loan/PayList.vue